module.exports = __webpack_public_path__ + "img/hi-res-iohouse-13.c06d9fa9.jpg";